// eslint-disable-next-line no-undef
export const isStandalone = !!(process.env.REACT_APP_STANDALONE && process.env.REACT_APP_STANDALONE === 'true')

export const channelToken = isStandalone
  ? window.location.pathname.split('/')[2] || ''
  : document.getElementById('nixi1_chatbot')?.getAttribute('channelToken') || ''
